import React, { useState, useEffect, useContext } from "react";
import "./foodCategory.css";
import { ContextProvider } from "../../App";
import { NavLink } from "react-router-dom";
import axios from "axios";

// import module
import SubCategories from "./SubCategories.jsx";
import Footer from "../../common/Footer.jsx";
import Header from "../../common/Header";
import AuthorizedHeader from "../../common/authorized/AuthorizedHeader";

import MobileSubCategories from "./MobileSubCategories";

import { foodCategoriesData } from "./foodCategoriesData"

export default function Categories() {
  const { isMobile, authState, authDispatch } = useContext(ContextProvider);

  // states of project to manage data
  const [subCat, setSubCat] = useState([]); //filter data that filter data on click
  const [title, setTitle] = useState("");
  const [active, setActive] = useState(""); // selected item by default
  console.log(foodCategoriesData)
  
  const getAllCategories = () => {
    authDispatch({ type: "ALL_CATEGORIES", payload: foodCategoriesData });
  };
  // const getAllCategories = async () => {
  //   const response = await axios.get("/api/v1/categories");
  //   authDispatch({ type: "ALL_CATEGORIES", payload: response.data.body });
  // };

  // onclick event to filter array
  const handleClick = (id, title) => {
    const subCatSingle = authState.categories.filter((item) => item._id === id); // checking condition to selected food item
    setSubCat(subCatSingle);
    setTitle(title);
    setActive(id);
  };

  // lifecycle hook to run component once at first time by default
  useEffect(() => {
    getAllCategories();
  }, []); //dependency

  useEffect(() => {
    const subCatSingle = authState.categories.filter(
      (item, index) => index === 0
    ); // array filter method
    setSubCat(subCatSingle);
  }, [authState.categories]); //dependency

  return (
    <>
      <div>
        {authState.loggedIn === true ? <AuthorizedHeader /> : <Header />}
      </div>
      {isMobile ? (
        <div className="responsive_category_container">
          {authState.categories.map((item) => {
            return <MobileSubCategories key={item._id} item={item} />;
          })}
        </div>
      ) : (
        <div
          className="category_container"
          style={{ backgroundColor: "#F9F9F9" }}
        >
          <div className="category_content_container">
            {authState.categories.map((item, index) => {
              const activeClass =
                active === item._id ? "mainCatDiv" : "mainCatDiv2"; //append class based on conditional rendering
              return (
                <div
                  key={item._id}
                  style={{ position: "relative" }}
                  onClick={() => handleClick(item._id, item.title)} // pass argument through function onClicked
                >
                  <img
                    src={item.thumbnails}
                    className={activeClass}
                    alt="card-img"
                    style={{
                      marginLeft: ".4rem",
                      marginRight: ".4rem",
                      marginTop: "1.2rem",
                      width: "260px",
                      height: "190px",
                      borderRadius: 8,
                      objectFit:"cover"
                    }}
                  />
                  <h3 className="imgtitle">{item.title}</h3>
                </div>
              );
            })}
            <hr />
          </div>
          <div>
            <SubCategories subCat={subCat} title={title} />
          </div>
        </div>
      )}
      <div className="order_btn_div">
        <NavLink to="/food/order/selections-plan">
          <button type="button" className="order_now_btn">
            Order Now
          </button>
        </NavLink>
      </div>
      <Footer footerWidth={isMobile ? "100%" : "75%"} />
    </>
  );
}
